// src/components/ui/Table.jsx
export function Table({ children }) {
  return <table className="w-full text-sm">{children}</table>;
}

export function Th({ children, className = "" }) {
  return (
    <th className={`p-3 text-left font-semibold text-slate-500 dark:text-slate-400 ${className}`}>
      {children}
    </th>
  );
}

export function Td({ children, className = "" }) {
  return <td className={`p-3 align-top text-slate-700 dark:text-slate-300 ${className}`}>{children}</td>;
}